import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  HStack,
  Image,
  Box,
  useColorModeValue,
  useBreakpoint,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { spacing, Typography } from '@/kit/antipad-ui';
import { Button as ButtonKit } from '@/kit/antipad-ui/Button';

interface WarningTokenModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  tokenSymbol: string;
  tokenIcon?: string;
  reasons: string[];
}

export const WarningTokenModal: React.FC<WarningTokenModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  onCancel,
  tokenSymbol,
  tokenIcon,
  reasons,
}) => {
  const bgColor = "#1d1d1d";
  const warningColor = useColorModeValue('orange.500', 'orange.300');
  const screen = useBreakpoint();
  const isMobile = screen === 'base' || screen === 'sm';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={bgColor} borderRadius="20px" mx={isMobile ? '4px' : '0px'}>
        <ModalHeader>
          <HStack spacing={3}>
            <WarningIcon color={warningColor} />
            <Typography>Warning: Token Not Recommended</Typography>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <HStack spacing={3}>
              <Image
                src={tokenIcon || `https://cryptologos.cc/logos/${tokenSymbol.toLowerCase()}-${tokenSymbol.toLowerCase()}-logo.png`}
                fallbackSrc="https://via.placeholder.com/40"
                boxSize="40px"
                borderRadius="full"
                alt={tokenSymbol}
              />
              <Typography variant='large_heading'>{tokenSymbol}</Typography>
            </HStack>

            <Box>
              <Typography className={spacing({ mb: '2x' })}>This token might have risks due to one of these reasons:</Typography>
              <VStack align="start" spacing={2} pl={4}>
                {reasons.map((reason, index) => (
                  <HStack key={index} spacing={2} color={warningColor}>
                    <Typography>•</Typography>
                    <Typography>{reason}</Typography>
                  </HStack>
                ))}
              </VStack>
              <Typography className={spacing({ mt: '4x' })} color="var(--color-content-tertiary)">
                Including this token might affect the success rate of other transactions in your portfolio copy.
              </Typography>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3} wrap={isMobile ? 'wrap' : 'nowrap'}>
            <ButtonKit fullWidth={isMobile} variant="ghost" onClick={onCancel}>
              Cancel Selection
            </ButtonKit>
            <ButtonKit fullWidth={isMobile} onClick={onConfirm}>
              Include Anyway
            </ButtonKit>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 